import React from 'react'
import photo from '../../assets/m2c.png'
import mbbs from '../../assets/mbbsss.png'
import mecca2c from '../../assets/mecca2c.png'
import ibrahimfamily from '../../assets/ibrahim.png'
import nambb from '../../assets/nambb.png'
import proclaim from '../../assets/proclaim.png'
import prayer from '../../assets/crossde.png'
import invisible from '../../assets/invis.png'
import hope from '../../assets/hope.png'
import './Cards.css'

const Cards = () => {
   const orbitImages = [
    { src: mbbs, href: "https://mbbs.academy/" },
    { src: mecca2c, href: "https://meccatochrist.org/" },
    { src: ibrahimfamily, href: "https://abrahamic.family/" },
    { src: nambb, href: "https://nambb.associates/" },
    { src: proclaim, href: "https://proclaimpublishers.com/" },
    { src: prayer, href: "https://meccaprayer.house/" },
    { src: invisible, href: "https://invisible.bible/" },
    { src: hope, href: "https://biblebasedhope.com/" }
    
  ];
  return (
   <div className="gallery-wrapper">
      <div className="gallery-container">
        <div className="center-image">
          <a  href target="_blank" rel="noopener noreferrer">
            <img src={photo} alt="Center" />
          </a>
        </div>

        {orbitImages.map((img, idx) => (
          <div key={idx} className={`orbit-image orbit-${idx + 1}`}>
            <a href={img.href} target="_blank" rel="noopener noreferrer">
              <img src={img.src} alt={`Orbit ${idx + 1}`} />
            </a>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Cards
